(function () {
    let mainWindow = $(window);
    mainWindow.on('scroll', function () {
        if (mainWindow.scrollTop() > 0) {
            $('.header-area').addClass('header-sticky');
        } else {
            $('.header-area').removeClass('header-sticky');
        }
    });

    let $monthlyBtn = $('#monthly-btn'),
        $annualBtn  = $('#annual-btn'),
        $prices     = $('.pricing-table .price');

    function toggleBilling(mode) {
        if (mode === 'monthly') {
            $monthlyBtn.addClass('active');
            $annualBtn.removeClass('active');
        } else {
            $annualBtn.addClass('active');
            $monthlyBtn.removeClass('active');
        }

        $prices.each(function() {
            let $price   = $(this),
                monthly  = $price.data('monthly'),
                annual   = $price.data('annual');
            if (monthly === undefined || annual === undefined) return;
            $price.text(mode === 'monthly' ? monthly : annual);
        });
    }

    $monthlyBtn.on('click', function() {
        toggleBilling('monthly');
    });

    $annualBtn.on('click', function() {
        toggleBilling('annual');
    });

    $('#demoRequestForm').on('submit', function(e) {
        e.preventDefault();
        let email = $('#demoRequestEmail').val();
        $.ajax({
            url: 'https://api.anyquest.ai/contactus',
            type: 'POST',
            data: JSON.stringify({
                name: "AQ Website",
                email: email,
                message: 'Demo Request',
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function() {
                $('#demoRequestModal').modal('toggle');
                $('#onSuccessModal').modal('toggle');
            },
            error: function() {
                $('#demoRequestModal').modal('toggle');
                $('#onErrorModal').modal('toggle');
            }
        });
        return false;
    });

    $('#earlyAccessForm').on('submit', function(e) {
        e.preventDefault();
        let name = $('#earlyAccessName').val();
        let email = $('#earlyAccessEmail').val();
        let message = $('#earlyAccessAbout').val();
        $.ajax({
            url: 'https://api.anyquest.ai/contactus',
            type: 'POST',
            data: JSON.stringify({
                name: name,
                email: email,
                message: message
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function() {
                $('#earlyAccessName').val('');
                $('#earlyAccessEmail').val('');
                $('#earlyAccessAbout').val('');
                $('#earlyAccessRequestModal').modal('toggle');
                $('#onSuccessModal').modal('toggle');
            },
            error: function() {
                $('#earlyAccessRequestModal').modal('toggle');
                $('#onErrorModal').modal('toggle');
            }
        });
        return false;
    });

    $('#partnershipRequestForm').on('submit', function(e) {
        e.preventDefault();
        let name = $('#partnershipRequestName').val();
        let email = $('#partnershipRequestEmail').val();
        let message = $('#partnershipRequestAbout').val();
        $.ajax({
            url: 'https://api.anyquest.ai/contactus',
            type: 'POST',
            data: JSON.stringify({
                name: name,
                email: email,
                message: "Partnership request: " + message
            }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function() {
                $('#partnershipRequestName').val('');
                $('#partnershipRequestEmail').val('');
                $('#partnershipRequestAbout').val('');
                $('#partnershipRequestRequestModal').modal('toggle');
                $('#onSuccessModal').modal('toggle');
            },
            error: function() {
                $('#partnershipRequestRequestModal').modal('toggle');
                $('#onErrorModal').modal('toggle');
            }
        });
        return false;
    });

    const commonDomains = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com"];

    // Function to extract the preferred account name from an email
    function extractAccountName(email) {
        const parts = email.split("@");
        if(parts.length !== 2) return "";
        let domain = parts[1].toLowerCase();
        const domainParts = domain.split(".");
        return domainParts.length >= 3 ? domainParts[1] : domainParts[0];
    }

    // Validate business email
    function isBusinessEmail(email) {
        const domain = email.split("@")[1]?.toLowerCase() || "";
        return domain && !commonDomains.includes(domain);
    }

    $("#email").on("change", function() {
        const emailVal = $(this).val().trim();
        if (!isBusinessEmail(emailVal)) {
            $("#emailError").text("Please use a valid business email address.");
            $("#accountName").val("");
        } else {
            $("#emailError").text("");
            let candidate = extractAccountName(emailVal);
            $.ajax({
                url: "https://api.anyquest.ai/tenants/generate-subdomain/" + candidate,
                type: "GET",
                success: function(data) {
                    // Expected response: { subdomain: "modified-subdomain" }
                    $("#accountName").val(data.subdomain);
                },
                error: function(err) {
                    console.log(err);
                    $("#emailError").text("Error generating subdomain. Please try again.");
                    $("#accountName").val("");
                }
            });
        }
    });

    // Navigation from Step 1 to Step 2
    $("#nextToStep2").on("click", function() {
        // Validate basic fields for step 1
        const organization = $("#organization").val().trim();
        const firstName = $("#firstName").val().trim();
        const lastName = $("#lastName").val().trim();
        const emailVal = $("#email").val().trim();
        const subDomain = $("#accountName").val().trim();

        if(!organization || !firstName || !lastName || !emailVal || !subDomain) {
            alert("Please complete all required fields.");
            return;
        }
        if (!isBusinessEmail(emailVal)) {
            alert("Please enter a valid business email address.");
            return;
        }
        $("#step1").removeClass("active");
        $("#step2").addClass("active");
    });

    // Navigation back to Step 1
    $("#backToStep1").on("click", function() {
        $("#step2").removeClass("active");
        $("#step1").addClass("active");
    });

    // Submit the signup form via AJAX to /signup endpoint.
    $("#submitSignup").on("click", function() {
        // Validate additional users emails if provided
        let valid = true;
        const user1Email = $("#user1Email").val().trim();
        if (user1Email && !isBusinessEmail(user1Email)) {
            $("#user1EmailError").text("Please enter a valid business email.");
            valid = false;
        } else {
            $("#user1EmailError").text("");
        }
        const user2Email = $("#user2Email").val().trim();
        if (user2Email && !isBusinessEmail(user2Email)) {
            $("#user2EmailError").text("Please enter a valid business email.");
            valid = false;
        } else {
            $("#user2EmailError").text("");
        }
        if (!valid) {
            alert("Please correct the errors before submitting the form.");
            return;
        }

        // Build JSON payload according to the TenantSignupRequest structure.
        // Assign "ADMIN" role to the primary user and "USER" to additional users.
        const payload = {
            organization: $("#organization").val().trim(),
            subDomain: $("#accountName").val().trim(),
            promotionCode: $("#promoCode").val().trim() || null,
            users: []
        };

        // Main user (required)
        payload.users.push({
            firstName: $("#firstName").val().trim(),
            lastName: $("#lastName").val().trim(),
            email: $("#email").val().trim(),
            role: "ADMIN"
        });

        // Optional additional user 1
        if ($("#user1Email").val().trim() !== "" &&
            $("#user1Email").val().trim().toLowerCase() !== $("#email").val().trim().toLowerCase() &&
            $("#user1FirstName").val().trim() !== "" &&
            $("#user1LastName").val().trim() !== "") {
            payload.users.push({
                firstName: $("#user1FirstName").val().trim(),
                lastName: $("#user1LastName").val().trim(),
                email: $("#user1Email").val().trim(),
                role: "CONTRIBUTOR"
            });
        }

        // Optional additional user 2
        if ($("#user2Email").val().trim() !== "" &&
            $("#user2Email").val().trim().toLowerCase() !== $("#email").val().trim().toLowerCase() &&
            $("#user2FirstName").val().trim() !== "" &&
            $("#user2LastName").val().trim() !== "") {
            payload.users.push({
                firstName: $("#user2FirstName").val().trim(),
                lastName: $("#user2LastName").val().trim(),
                email: $("#user2Email").val().trim(),
                role: "CONTRIBUTOR"
            });
        }

        $.ajax({
            type: "POST",
            url: "https://api.anyquest.ai/tenants/signup",
            contentType: "application/json",
            data: JSON.stringify(payload),
            success: function(response) {
                // On success, naviate to Step 3
                $(".wizard-step.active").removeClass("active");
                $("#step3").addClass("active");
            },
            error: function(xhr, status, error) {
                alert("Signup failed: " + error);
            }
        });
    });

})();
